import { render, staticRenderFns } from "./widget-template-gallery.vue?vue&type=template&id=b690aae4&scoped=true&"
import script from "./widget-template-gallery.vue?vue&type=script&lang=js&"
export * from "./widget-template-gallery.vue?vue&type=script&lang=js&"
import style0 from "./widget-template-gallery.vue?vue&type=style&index=0&id=b690aae4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b690aae4",
  null
  
)

export default component.exports